<head>
<style>
.card {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  max-width: 300px;
  margin: auto;
  text-align: center;
  font-family: arial;
}

.price {
  color: grey;
  font-size: 22px;
}

.card button {
  border: none;
  outline: 0;
  padding: 12px;
  color: white;
  background-color: #000;
  text-align: center;
  cursor: pointer;
  width: 100%;
  font-size: 18px;
}

.card button:hover {
  opacity: 0.7;
}
</style>
</head>
<body>


<div class="card">
  <img src="images/iphone11pic.jpg" alt="Denim Jeans" style="width:100%">
  <h1>iPhone 11 Battery Replacement</h1>
  <p class="price">$100.00</p>
  <p>Extra $25 and it'll be done in 2 hours or less!</p>
</div>

</body>
<body>

<div class="card">
  <img src="images/iphone11screen2.jpg" alt="Denim Jeans" style="width:100%">
  <h1>iPhone 11 Screen Replacement</h1>
  <p class="price">$150.00</p>
  <p>Extra $50 and it'll be done in 2 hours or less!</p>
</div>

</body>

